import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaBus, FaCar, FaParking } from 'react-icons/fa';

const LocationContainer = styled.div`
  padding-top: ${props => props.theme.sizes.headerHeight};
  max-width: ${props => props.theme.sizes.maxWidth};
  margin: 0 auto;
  padding: 120px 20px 60px;
`;

const Title = styled.h1`
  text-align: center;
  color: ${props => props.theme.colors.primary};
  margin-bottom: 40px;
  font-size: 2.8rem;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const Description = styled.p`
  text-align: center;
  color: ${props => props.theme.colors.lightText};
  margin-bottom: 60px;
  line-height: 1.6;
`;

const MapSection = styled(motion.div)`
  margin-bottom: 60px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.medium};
  cursor: pointer;
  
  img {
    width: 100%;
    height: 600px;
    object-fit: cover;
  }
`;

const TransportGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 60px;
`;

const BusinessInfo = styled.div`
  margin-top: 60px;
  padding: 20px;
  color: ${props => props.theme.colors.lightText};
  line-height: 1.8;
  
  p {
    margin: 5px 0;
  }
`;

const TransportCard = styled(motion.div)`
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: ${props => props.theme.shadows.medium};

  h3 {
    color: ${props => props.theme.colors.primary};
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    font-size: 20px;

    svg {
      font-size: 24px;
    }
  }

  p {
    color: ${props => props.theme.colors.text};
    line-height: 1.8;
    margin-bottom: 10px;

    &.sub-info {
      color: ${props => props.theme.colors.lightText};
      font-size: 0.95em;
    }
  }
`;

const FooterInfo = styled.div`
  background-color: ${props => props.theme.colors.background};
  padding: 40px 20px;
  margin-top: 60px;

  h2 {
    color: ${props => props.theme.colors.primary};
    margin-bottom: 20px;
  }

  p {
    color: ${props => props.theme.colors.text};
    margin: 8px 0;
    line-height: 1.6;
  }
`;

function Location() {
  const handleMapClick = () => {
    window.open('https://naver.me/GrmK5Y63', '_blank');
  };

  return (
    <LocationContainer>
      <Title>오시는 길</Title>
      <Description>
        편리한 위치와 접근성 좋은 교통으로<br />
        환자분들의 내원이 수월합니다.
      </Description>

      <MapSection
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        onClick={handleMapClick}
      >
        <img src="/images/map.jpg" alt="서울쥬니어치과 위치" />
      </MapSection>

      <TransportGrid>
        <TransportCard
          whileHover={{ y: -5 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h3><FaMapMarkerAlt /> 주소</h3>
          <p>경기도 이천시 중리천로 76,<br />라온팰리스 2층</p>
        </TransportCard>

        <TransportCard
          whileHover={{ y: -5 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <h3><FaParking /> 주차 안내</h3>
          <p>건물 내 지하주차장 이용 가능</p>
          <p>1시간 무료 주차 제공</p>
        </TransportCard>

        <TransportCard
          whileHover={{ y: -5 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <h3><FaBus /> 버스 이용 시</h3>
          <p>이천터미널 하차 후 도보 5분</p>
          <p className="sub-info">8번, 10번, 21-1번, 3401번, 8203번</p>
        </TransportCard>

        <TransportCard
          whileHover={{ y: -5 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <h3><FaCar /> 자가용 이용 시</h3>
          <p>내비게이션에 '서울쥬니어치과' 검색</p>
          <p>라온팰리스 지하주차장 이용</p>
        </TransportCard>
      </TransportGrid>
    </LocationContainer>
  );
}

export default Location; 